import type {
    WorkInProgressEmailNotificationResult,
    WorkInProgressTask,
} from '../types/work-in-progress';

/**
 * Home V2 工作中任务接口。
 */
export interface WorkInProgressApi {
    /**
     * 获取当前用户最近的工作中任务。
     *
     * @returns 服务端已排序的任务列表。
     */
    getTasks(): Promise<WorkInProgressTask[]>;

    /**
     * 为指定任务开启完成邮件通知。
     *
     * @param taskId 任务唯一标识。
     * @returns 邮件通知的最新状态。
     */
    requestEmailNotification(taskId: string): Promise<WorkInProgressEmailNotificationResult>;

    /**
     * 上报指定任务的报告已成功导出。
     *
     * @param taskId 任务唯一标识。
     */
    markTaskExported(taskId: string): Promise<void>;
}

/**
 * Home V2 工作中任务接口的依赖注入标识。
 */
export const WorkInProgressApi = Symbol('WorkInProgressApi');
